/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var notEmpty = function notEmpty(x) {
  return !!x && x !== true;
};
function _default() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args.length == 1 && Array.isArray(args[0])) {
    args = args[0];
  }
  return (0, _toConsumableArray2.default)(args).filter(notEmpty).join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/join.js
// module id = 20
// module chunks = 0